import filter from 'lodash/filter';
import isUndefined from 'lodash/isUndefined';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import each from 'lodash/each';
import find from 'lodash/find';

import { OnboardingServiceModule } from 'services/data/onboarding.service';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { AppSettingsModule } from 'services/settings.provider';

import { DataServiceModule } from './data.service';

export const ExtensionServiceModule = angular
    .module('vln.appStore.components', [
        OnboardingServiceModule,
        LaunchDarklyServiceModule,
        DataServiceModule,
        AppSettingsModule
    ]).service('extensionService', (
        dataService,
        onboardingService,
        $http,
        settings,
        $q,
        launchDarklyService
    ) => {
        return {
            getExtensions: getExtensions,
            getTenantExtensions: getTenantExtensions,
            installExtension: installExtension,
            getPurchasedExtensions: getPurchasedExtensions
        };

        function getExtensions(app) {
            return $q.all([
                $http.get(`${process.env.BASE_API_URL}/marketplace/extensions`),
                launchDarklyService.allFlags()
            ]).then(([allExtensions, ldFlags]) => {
                return filter(allExtensions.data.items, (extn) => {
                    return extn.isAvailable &&
                            (isUndefined(extn.code)
                                || isUndefined(ldFlags[extn.code])
                                || ldFlags[extn.code] === true);
                });
            }).then((res) => {
                return filterExtensions(app, res);
            });
        }

        function getTenantExtensions(app) {
            return dataService.getAll(settings.api.purchasedextensions).then((res) => {
                return uniqBy(filterExtensions(app, res.items), 'extensionId');
            }).then(sortExtensions);
        }

        function filterExtensions(app, extensions) {
            // TODO: learn where extensions are stored once installed (hint: not just MARS) then maybe remove this code
            const withoutDescription = filter(extensions, (el) => {
                return el.directive !== 'description';
            });

            return app ? filter(withoutDescription, (item) => {
                return angular.isArray(item.extends) && item.extends.indexOf(app) !== -1;
            }) : withoutDescription;
        }

        function sortExtensions(extensions) {
            return sortBy(extensions, 'title');
        }

        function getPurchasedExtensions() {
            //This will have list of purchased extensions with extension details.
            return $q.all([getExtensions(), getTenantExtensions()])
                .then((res) => {
                    let allExtensions = res[0];
                    let tenantExtensions = res[1];
                    let extensions = [];

                    each(tenantExtensions, (tenantExtension) => {
                        extensions.push(find(allExtensions, { id: tenantExtension.extensionId }));
                    });
                    return extensions;
                });
        }

        function installExtension(app) {
            return $http.post(`${process.env.BASE_API_URL}/marketplace/extensions/orders`, app).then((data) => {
                onboardingService.completeTask('run.installExtension');
                return data;
            });
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/data/extension.service.js